class Toolkit extends HTMLElement {
    constructor() {
      super();

      this.currentSlide = 0;
      this.slideTimer = null;
      this.slideInterval = 3000;
      this.sliderItem = this.querySelectorAll(".icon-text");
      this.slideCount = this.sliderItem?.length;
    }

    connectedCallback() {
      if( window.innerWidth < 880 ){
        this.startAutoplay();
      }
    }

    disconnectedCallback() {
      if( window.innerWidth < 880 ){
        this.stopAutoplay();
      }
    }

    startAutoplay() {
      this.slideTimer = setInterval(() => {
        this.nextSlide();
      }, this.slideInterval);
    }

    stopAutoplay() {
      clearInterval(this.slideTimer);
    }

    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slideCount;
      this.showSlide(this.currentSlide);
    }

    showSlide(slideIndex) {
      this.sliderItem.forEach(slide => {
        if (slide.classList.contains('active'))
            slide.classList.remove('active');
            slide.style.transform = "translateX(100%)"; // set initial position for slide transition
      });
      setTimeout(() => {
        this.sliderItem[slideIndex].classList.add('active');
        this.sliderItem[slideIndex].style.transform = "translateX(0%)"; // trigger slide transition
      }, 100);
    }
}
customElements.define('site-toolkit', Toolkit);
